/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './styles.scss';

const Clickwrap = ({
  checked,
  isInvalid,
  name,
  isDisabled = false,
  color = '#3d3d3d',
  backgroundColor,
  className = '',
  labelClassName='',
  colorFill = false,
  ...restProps
}) => {
  let backgroundFill = checked ? color : backgroundColor || '#fff';
  if (colorFill) {
    backgroundFill = color;
  }
  return (
    <div
      className={clsx('clickwrap', className)}
      style={{
        backgroundColor: isDisabled ? '#a7a7a7' : backgroundFill,
        borderColor: isInvalid ? '#ab5243' : color,
      }}
    >
      <input
        type="checkbox"
        id={name}
        checked={checked}
        {...restProps}
      />
      <label
        htmlFor={name}
        className={clsx(`clickwrap_checkbox${  checked ? '_checked' : ''}`, labelClassName)}
      />
    </div>
  );
};

Clickwrap.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
};

Clickwrap.defaultProps = {
  checked: false,
};

export default Clickwrap;
